<select
  [formControl]="inputControl"
  [ngClass]="widthClass"
  class="h-8 rounded border border-solid border-gray-400 focus:outline-none text-xs px-2 text-gray-700"
>
  <option value="" selected disabled hidden>{{ titleSellect }}</option>
  <option class="text-xs" *ngFor="let option of options; let i = index" [value]="options[i].id || options[i].categoryId">{{options[i].name}}</option>
</select>
